import { Component, Inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
// 1. Importamos MapDirectionsService
import { GoogleMapsModule, MapDirectionsService } from '@angular/google-maps';
import { TicketService } from '../../services/ticket.service';
import { TicketDetail } from '../../models/ticket-model/tiket.model';

@Component({
  selector: 'app-map-general',
  standalone: true,
  imports: [MatIcon, MatButtonModule, GoogleMapsModule],
  templateUrl: './map-general.html',
  styleUrl: './map-general.css',
})
export class MapGeneral implements OnInit, OnDestroy {
  private intervalId: ReturnType<typeof setInterval> | null = null;
  public origin: google.maps.LatLngLiteral = { lat: 19.4326, lng: -99.1332 };
  public destination: google.maps.LatLngLiteral = { lat: 19.3034, lng: -99.146 };

  public center: google.maps.LatLngLiteral = { lat: 19.368, lng: -99.1396 };
  public zoom = 11;

  // 2. Signal para guardar la ruta que nos devuelva Google
  public directionsResult = signal<google.maps.DirectionsResult | undefined>(undefined);

  constructor(
    public dialog: MatDialog,
    public ticketService: TicketService,
    public dialogRef: MatDialogRef<MapGeneral>,
    @Inject(MAT_DIALOG_DATA) public data: TicketDetail,
    private directionsService: MapDirectionsService, // <-- 3. Inyectamos el servicio
  ) {}

  ngOnInit(): void {
    this.getTrayectory();
    this.intervalId = setInterval(() => this.getTrayectory(), 30000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private getTrayectory() {
    this.ticketService.getPositionEngineer(this.data.EngineerId).subscribe((Ing) => {
      this.origin = {
        lat: parseFloat(Ing?.Data?.Latitude || '0'), // Coordenadas fijas para el destino
        lng: parseFloat(Ing?.Data?.Longitude || '0'),
      };
      this.destination = {
        lat: parseFloat(this.data.Location.Latitude),
        lng: parseFloat(this.data.Location.Longitude),
      };

      this.center = {
        lat: (this.origin.lat + this.destination.lat) / 2,
        lng: (this.origin.lng + this.destination.lng) / 2,
      };

      // B) Creamos la petición de ruta (En auto)
      const request: google.maps.DirectionsRequest = {
        origin: this.origin,
        destination: this.destination,
        travelMode: google.maps.TravelMode.DRIVING,
      };

      // C) Ejecutamos la petición a la API de Google
      this.directionsService.route(request).subscribe({
        next: (response) => {
          if (response.result) {
            // Si todo sale bien, guardamos la ruta en el signal
            this.directionsResult.set(response.result);
          }
        },
        error: (error) => {
          console.error('Error obteniendo la ruta:', error);
        },
      });
    });
  }

  public closeModal(): void {
    this.dialogRef.close(null);
  }
}
